import PropTypes from 'prop-types';
import React, { useCallback, useContext, useState } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withValidation } from '@bingads-webui-react/validation';
import {
  Field,
  Label,
  Textarea,
  useId,
} from '@fluentui/react-components';
import { useKeywordInputStyles } from '../../styles';
import { getCustomValidator } from './keyword-textarea-validation';
import { errorMessages } from '../../errors';

const ValidatedTextarea = withValidation(Textarea);

export const KeywordTextarea = ({
  isDisabled,
  keywordString,
  onChange,
  showError,
}) => {
  const textareaId = useId('keywordTextarea');

  const i18n = useContext(I18nContext);
  const placeholder = i18n.getString(_TL_('Enter keywords separated by commas'));

  const [fieldProps, setFieldProps] = useState(null);

  const onChangeTextarea = useCallback((e, data) => {
    if (data.length) {
      const { value } = data[0];
      onChange(value);
    }
  }, [onChange]);

  const styles = useKeywordInputStyles();

  const validator = getCustomValidator();

  const onValidateKeywords = useCallback(({ isValid, messages }) => {
    if (isValid) {
      setFieldProps(null);
    } else {
      const message = messages[0];

      if (typeof message === 'object') {
        setFieldProps({
          validationMessage: i18n.getString(errorMessages[message.key], message.data),
          validateState: 'error',
        });
      } else {
        setFieldProps({
          validationMessage: i18n.getString(errorMessages[message]),
          validationState: 'error',
        });
      }
    }
  }, [i18n]);

  return (
    <div className={styles.textareaContainer}>
      <Label
        disabled={isDisabled}
        id={textareaId}
        required
      >
        {i18n.getString(_TL_('Enter keywords separated by commas'))}
      </Label>
      <Field {...(showError ? fieldProps : null)}>
        <ValidatedTextarea
          aria-labelledby={textareaId}
          className={styles.textarea}
          disabled={isDisabled}
          onChange={onChangeTextarea}
          placeholder={placeholder}
          textarea={{ className: styles.textarea }}
          validationProps={{
            data: { keywordString },
            field: 'keywordString',
            onValidate: onValidateKeywords,
            validator,
          }}
        />
      </Field>
    </div>
  );
};

KeywordTextarea.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  keywordString: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  showError: PropTypes.bool,
};

KeywordTextarea.defaultProps = {
  showError: false,
};
